<template>
  <toast v-model="showToast" v-if="showToast" :msg="msg"></toast>
</template>
<script>
import Toast from '@/components/Toast'
import { fetchHouse, fetchFavirote, doFavirote, fetchHouseV3 } from '@/services/mayihouse.js'
import { formatText } from '@/utils/q_business'
import { errorReport } from '@/utils/index.js'
import mayiLogin from '@/utils/mayiLogin.js'
import { mpUtils } from '@tujia/fe-lib-bridge'

export default {
  mixins: [mayiLogin],
  components: {
    Toast
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      showToast: false,
      msg: 'hello world'
    }
  },
  watch: {
    payLoad(newVal) {
    // eslint-disable-next-line
      if (newVal && newVal.type === 'openHouseInfo') {
        this.showHouseInfo(newVal.data)
      } else if (newVal && newVal.type === 'favoriteHouse') {
        this.doFavorite(newVal.data)
      }
    }
  },
  mounted() {
    this.initHouses()
  },
  methods: {
    /**
     * 跳转房屋详情
     * @param {Number} unitId 房屋id
     * @param {String} startDate 开始时间
     * @param {String} endDate 结束时间
     */
    async showHouseInfo(unitId, startDate, endDate) {
      const { isJumpApp } = this.compProps
      let moment = require('moment')
      startDate = startDate || moment().format('YYYY-MM-DD')
      endDate = endDate || moment().add('days', 1).format('YYYY-MM-DD')
      try {
        // 这个埋点方案不是很好。想想以后改进一下。其他地方同。
        if (window._vds && window._vds.track) {
          window._vds.track(`${this.$root.isMobile ? 'H5' : 'PC'}_houseid_cms`, {
            [`${this.$root.isMobile ? 'H5' : 'PC'}_houseid_cms_bian`]: unitId,
            'activityid_cms': this.$root.promotionId
          })
        }
        let atmQuery = ''
        if (this.$root.atm_source) {
          atmQuery = `&atm_source=${this.$root.atm_source}`
        }
        // 榜单需要带上级页面的入离日期
        if (this.compProps.mode === '6') {
          const { checkInDate = '', checkOutDate = '' } = this.$route.query
          startDate = checkInDate
          endDate = checkOutDate
        }
        if (this.platformEnv.isMpEnv && this.tjChannelId === 'tujia') {
          mpUtils.navigateTo({
            url: `/pages/tbnb/pages/common/webview/index?optionsData=${JSON.stringify({
              h5url: encodeURIComponent(`https://m.tujia.com/detail/${unitId}.htm?beginDate=${startDate}&endDate=${endDate}}`)
            })}`
          })
        } else {
          if (this.platformEnv.isMayiAppEnv) {
          // 跳转客户端房屋详情
            window.location.href = `https://app.tujia.com/go/unitdetail?id=${unitId}&start=${startDate}&end=${endDate}&isFromPromotion=true${atmQuery}&isFromPromotion=true${atmQuery}`
          } else if (this.platformEnv.isWxMpEnv) {
          // 跳转小程序房屋详情
          // eslint-disable-next-line
          wx.miniProgram.navigateTo({
              url: `/pages/unitDetails_v2/unitDetails?unitId=${unitId}`
            })
          } else if (this.platformEnv.isAliMpEnv) {
          // 支付宝webview ua
            this.jumpAliClientAndMP(unitId, isJumpApp)
          } else {
          // 移动端浏览器跳转房屋详情
            if (this.$root.isMobile) {
              window.location.href = `${process.env.VUE_APP_MAYI_HOST_HD}/room/${unitId}?${atmQuery}&isTujia=1`
            } else {
              window.location.href = `${process.env.VUE_APP_MAYI_PC_HOST_HD}/room/${unitId}.htm?${atmQuery}&isTujia=1`
            }
          }
        }
      } catch (e) {
        errorReport(e)
      }
    },
    /**
     * 收藏
     * @param {Object} house 房屋
     */
    async doFavorite(house) {
      try {
        const ret = await doFavirote(house.id, house.isLike)
        if (ret && ret.errcode === 0) {
          this.$emit('finish', { type: 'favirote', data: { id: house.id, isLike: !house.isLike } })
        } else if (ret && ret.errcode === 55004) {
          this.mayiLogin()
        }
      } catch (e) {
        this.msg = '系统开小差了，一会再试试吧'
        this.showToast = true
        errorReport(e)
      }
    },
    /**
     * 初始化房屋信息
     */
    async initHouses() {
      try {
        // 房屋列表缓存，暂时不加，产品需求
        // const cacheData = sessionStorage.getItem(this.compProps.elementId)
        // if (cacheData) {
        //   const data = JSON.parse(cacheData)
        //   this.$emit('init', data)
        // } else {
        const ids = []
        let faviroteIds = []
        const maxShowNumber = this.compProps.maxShowNumber
        this.compProps.houses.forEach((house) => {
          ids.push(house.id)
        })
        const aIds = this.compProps.promotionId && this.compProps.promotionId.split(',')
        let ret = {}
        if (this.compProps.mode === '6') {
          const { checkInDate = '', checkOutDate = '' } = this.$route.query
          ret = await fetchHouseV3(ids, aIds || [], this.compProps.priceTime, maxShowNumber, this.$root.promotionId, this.compProps.needNoRepositoty, this.compProps.mode, checkInDate, checkOutDate)
        } else {
          ret = await fetchHouse(ids, aIds || [], this.compProps.priceTime, maxShowNumber, this.$root.promotionId, this.compProps.needNoRepositoty, this.compProps.mode)
        }
        let faviroteRet = await fetchFavirote(ids)
        if (faviroteRet && faviroteRet.errcode === 0) {
          faviroteIds = faviroteRet.data?.houseIdList || []
        }
        let total = 0
        let items = []
        if (ret.errcode === 0 && ret.data) {
          total = ret.data.totalCount
          items = ret.data.items
        }

        if (total > +maxShowNumber) {
          total = +maxShowNumber
          items = items.splice(0, total)
        }
        let hasPriceTags = false
        let hasSpecialTags = false
        let houseLabelText = ''
        items = items && items.map((item) => {
          const house = this.compProps.houses.find((itemHouse) => {
            return itemHouse.id + '' === item.unitId + ''
          })
          const favirote = faviroteIds.find((faviroteId) => {
            return faviroteId === item.unitId
          })
          let priceTags = item.priceTags || []
          if (this.compProps.mode === '2') {
            priceTags = priceTags.splice(0, 1)
          }
          if (priceTags.length > 0) {
            hasPriceTags = true
          }
          let specialTags = item.specialTags || []
          if (specialTags.length > 0) {
            hasSpecialTags = true
          }
          if (this.compProps.mode === '6') {
            const { unitSummeries = [] } = item
            const HOUSELEVEL = unitSummeries.find((e) => { return e.textType === 'HOUSELEVEL' })
            const CANLIVEDESC = unitSummeries.find((e) => { return e.textType === 'CANLIVEDESC' })
            const COMMENT = unitSummeries.find((e) => { return e.textType === 'COMMENT' })
            houseLabelText = formatText([COMMENT?.text || '', HOUSELEVEL?.text || '', CANLIVEDESC?.text || ''], '·')
          }
          return {
            ...item,
            priceTags,
            comment: house.comment,
            isLike: favirote !== undefined,
            houseLabelText: houseLabelText
          }
        })
        items = items && items.map((item) => {
          return {
            ...item,
            hasPriceTags,
            hasSpecialTags
          }
        })
        const data = {
          totalCount: total,
          items: items
        }
        // sessionStorage.setItem(this.compProps.elementId, JSON.stringify(data))
        this.$emit('init', data)
        // }
      } catch (e) {
        this.msg = '系统开小差了，一会再试试吧' // 已经领取过了 // 好可惜，红包抢完了 // 系统开小差了，一会再试试吧
        this.showToast = true
        errorReport(e)
      }
    },
    jumpAliClientAndMP(id, isJump) {
      const appId = 2017041206663263
      const mpPage = encodeURIComponent('pages/unitDetails_v2/unitDetails')
      // beginDate=2019-06-08&endDate=2019-06-09&unitId=241557&peopleCount=1
      const mpQuery = `unitId=${id}`
      // eslint-disable-next-line no-undef
      window.location.href = `alipays://platformapi/startapp?appId=${appId}&page=${mpPage}&query=${encodeURIComponent(mpQuery)}`
    }
  }
}
</script>
